/**
 * Created by Bob.Gear on 3/05/14.
 */
//------------------------------------------------------------------------
//  projectTypeFilter Directive
//------------------------------------------------------------------------
angular.module("EICDataStream3.queryBuilder")
    .controller('projectTerrainFilterController', ['$scope',
      function ($scope) {
        $scope.componentName = "projectTerrainFilter";

        $scope.resetFilter = function () {
          $scope.clearProjectTerrainSelections();
        };

        $scope.clearProjectTerrainSelections = function () {
          $scope.criteria.projectOffshore = null;
          delete $scope.criteria["projectOffshore"];

          $scope.criteria.projectOnshore = null;
          delete $scope.criteria["projectOnshore"];
        };

        $scope.removeProjectTerrainFilter = function () {
          $scope.resetFilter();
          $scope.$parent.removeFilter("#projectTerrainFilter");
        };

        var setEitherRequiredValidity = function(isEitherChecked){
          $scope.projectTerrainFilterForm.onshore.$setValidity("eitherRequired", isEitherChecked || false);
          $scope.projectTerrainFilterForm.offshore.$setValidity("eitherRequired", isEitherChecked || false);
        }

        $scope.$watch("criteria.projectOffshore", function(newval){
          if(!newval && !$scope.criteria.projectOnshore && $scope.projectTerrainFilterForm.$dirty){
            $scope.criteria.projectOnshore = true;
          }

          var isValid = $scope.criteria.projectOffshore || $scope.criteria.projectOnshore;
          setEitherRequiredValidity(isValid);
        }, true);

        $scope.$watch("criteria.projectOnshore", function (newval) {
          if (!newval && !$scope.criteria.projectOffshore && $scope.projectTerrainFilterForm.$dirty){
            $scope.criteria.projectOffshore = true;
          }

          var isValid = $scope.criteria.projectOffshore || $scope.criteria.projectOnshore;
          setEitherRequiredValidity(isValid);
        }, true);



      }])
    .directive('projectTerrainFilter', ['$compile',
      function ($compile) {
        return {
          replace:     true,  // replace the placeholder element with the template
          restrict:    'A',   // usage: <div projectNameFilter />
          templateUrl: "../app-ds3/search/queryBuilder/filters/projectTerrainFilter.tmpl.html",

          link: function ($scope, iElement, iAttrs) {
            $scope.projectTerrainFilterForm.setEitherRequiredValidity =  function(validity) {

              $scope.projectTerrainFilterForm.onshore.$setValidity("eitherRequired", validity);
              $scope.projectTerrainFilterForm.offshore.$setValidity("eitherRequired", validity);

            };

          },

          controller: 'projectTerrainFilterController'
        };
      }]);
//------------------------------------------------------------------------
